import {ILowFareService} from "./low-fare.service.interface";
import {Station} from "../stations/station.service.interface";
import {ServiceBase} from "../service-base";
import {
    IDotRezAvailabilityLowFarePassengers
} from "../dot-rez-api/data-contracts/requests/booking/lowfare-search.request";
import {IOneWayLowFareReader} from "./low-fare-readers/low-fare-reader.interface";
import {VoidOneWayLowFareReader} from "./low-fare-readers/void-low-fare-reader";
import {OneWayLowFareReader} from "./low-fare-readers/one-way-low-fare-reader";
import {NullableNumber, NullableString} from "../../types/nullable-types";
import {IFlightScheduleFilter} from "../flight-search/flights-schedule/flight-schedule-filter.interface";
import {IDotRezBookingSession} from "../dot-rez-api/session/booking-session/dot-rez-booking.session.interface";
import {IServiceFactory} from "../service-factory.interface";
import {LowFaresCache} from "./low-fares-cache";

export class LowFareService extends ServiceBase implements ILowFareService {

    constructor(services: IServiceFactory) {
        super(services);
        this._cache = new LowFaresCache(this.services);
    }

    private readonly _cache: LowFaresCache;

    createLowFareReader(originStation: Station,
                        destinationStation: Station,
                        getBookingSession: () => Promise<IDotRezBookingSession>,
                        getClassOfServices: () => Promise<string[]>,
                        getAnonymousAgentName: () => NullableString,
                        getMinPriceAmount: () => NullableNumber,
                        getCurrency: () => string,
                        scheduleFilter: IFlightScheduleFilter,
                        passengersCount: () => IDotRezAvailabilityLowFarePassengers): IOneWayLowFareReader {

        if (!this.services.configuration.data.marketing.enableLowFare) {
            return new VoidOneWayLowFareReader();
        }

        return new OneWayLowFareReader(
            originStation,
            destinationStation,
            this._cache,
            getBookingSession,
            getClassOfServices,
            getAnonymousAgentName,
            getMinPriceAmount,
            getCurrency,
            scheduleFilter,
            this.services,
            passengersCount);
    }
}


